import { useAppSelector } from "../redux/hooks";

export const useHasOrgContext = (): boolean =>
  useAppSelector((state) => state.authState.state?.type === "LoggedInWithOrgContext");
